// components/Footer.js
import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            <p>
                &copy; 2025 <a href="https://www.antiquaires-experts.fr/">Antiquaires Experts</a>. Site réalisé par{' '}
                <a href="https://antoineperry.fr" target="_blank" rel="noopener noreferrer">Antoine Perry</a>
                {' · '}
                <a href="https://www.dna-engineering.lu/" target="_blank" rel="noopener noreferrer">DNA Engineering</a>
                | Mentions légales | Plan du site | Politique de confidentialité
            </p>
        </footer>
    );
}

export default Footer;
